// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestMarks_root__2DgkE","rowExpanded":"RequestMarks_rowExpanded__2HdS2"};